export const GET_GROUPS_LIST = 'orders-groups/GET_GROUPS_LIST';
export const getGroupsListAction = payload => ({
	type: GET_GROUPS_LIST,
	payload,
});

export const SET_GROUPS_LIST = 'orders-groups/SET_GROUPS_LIST';
export const setGroupsListAction = payload => ({
	type: SET_GROUPS_LIST,
	payload,
});

export const SET_IS_GROUPS_LIST_LOADING = 'orders-groups/SET_IS_GROUPS_LIST_LOADING';
export const setIsGroupsListLoadingAction = payload => ({
	type: SET_IS_GROUPS_LIST_LOADING,
	payload,
});

export const GET_GROUPS_WITH_WAYS_LIST = 'orders-groups/GET_GROUPS_WITH_WAYS_LIST';
export const getGroupsWithWaysListAction = payload => ({
	type: GET_GROUPS_WITH_WAYS_LIST,
	payload,
});

export const SET_GROUPS_WITH_WAYS_LIST = 'orders-groups/SET_GROUPS_WITH_WAYS_LIST';
export const setGroupsWithWaysListAction = payload => ({
	type: SET_GROUPS_WITH_WAYS_LIST,
	payload,
});

export const SET_IS_GROUPS_WITH_WAYS_LIST_LOADING = 'orders-groups/SET_IS_GROUPS_WITH_WAYS_LIST_LOADING';
export const setIsGroupsWithWaysListLoadingAction = payload => ({
	type: SET_IS_GROUPS_WITH_WAYS_LIST_LOADING,
	payload,
});

export const GET_WAYS_LIST = 'orders-groups/GET_WAYS_LIST';
export const getWaysListAction = payload => ({
	type: GET_WAYS_LIST,
	payload,
});

export const SET_WAYS_LIST = 'orders-groups/SET_WAYS_LIST';
export const setWaysListAction = payload => ({
	type: SET_WAYS_LIST,
	payload,
});

export const SET_IS_WAYS_LIST_LOADING = 'orders-groups/SET_IS_WAYS_LIST_LOADING';
export const setIsWaysListLoadingAction = payload => ({
	type: SET_IS_WAYS_LIST_LOADING,
	payload,
});

export const GET_TYPES = 'orders-groups/GET_TYPES';
export const getTypesAction = payload => ({
	type: GET_TYPES,
	payload,
});

export const SET_TYPES = 'orders-groups/SET_TYPES';
export const setTypesAction = payload => ({
	type: SET_TYPES,
	payload,
});

export const SET_IS_TYPES_LOADING = 'orders-groups/SET_IS_TYPES_LOADING';
export const setIsTypesLoadingAction = payload => ({
	type: SET_IS_TYPES_LOADING,
	payload,
});

export const RESET_STATE = 'orders-groups/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});

export const GET_COLLECTION_GROUP_LIST = 'orders-groups/GET_COLLECTION_GROUP_LIST';
export const getCollectionGroupListAction = payload => ({
	type: GET_COLLECTION_GROUP_LIST,
	payload,
});

export const SET_COLLECTION_GROUP_LIST = 'orders-groups/SET_COLLECTION_GROUP_LIST';
export const setCollectionGroupListAction = (id, payload) => ({
	type: SET_COLLECTION_GROUP_LIST,
	id,
	payload,
});

export const SET_IS_COLLECTION_GROUP_LIST_LOADING = 'orders-groups/SET_IS_COLLECTION_GROUP_LIST_LOADING';
export const setIsCollectionGroupListLoadingAction = payload => ({
	type: SET_IS_COLLECTION_GROUP_LIST_LOADING,
	payload,
});

export const RESET_IS_COLLECTION_GROUP_LIST_LOADING = 'orders-groups/RESET_IS_COLLECTION_GROUP_LIST_LOADING';
export const resetIsCollectionGroupListLoadingAction = payload => ({
	type: RESET_IS_COLLECTION_GROUP_LIST_LOADING,
	payload,
});

export const GET_ORDERS_COLLECTION_GROUP_LIST = 'orders-groups/GET_ORDERS_COLLECTION_GROUP_LIST';
export const getOrdersCollectionGroupListAction = payload => ({
	type: GET_ORDERS_COLLECTION_GROUP_LIST,
	payload,
});

export const SET_ORDERS_COLLECTION_GROUP_LIST = 'orders-groups/SET_ORDERS_COLLECTION_GROUP_LIST';
export const setOrdersCollectionGroupListAction = (id, payload) => ({
	type: SET_ORDERS_COLLECTION_GROUP_LIST,
	id,
	payload,
});

export const SET_IS_ORDERS_COLLECTION_GROUP_LIST_LOADING = 'orders-groups/SET_IS_ORDERS_COLLECTION_GROUP_LIST_LOADING';
export const setIsOrdersCollectionGroupListLoadingAction = payload => ({
	type: SET_IS_ORDERS_COLLECTION_GROUP_LIST_LOADING,
	payload,
});

export const RESET_IS_ORDERS_COLLECTION_GROUP_LIST_LOADING =
	'orders-groups/RESET_IS_ORDERS_COLLECTION_GROUP_LIST_LOADING';
export const resetIsOrdersCollectionGroupListLoadingAction = payload => ({
	type: RESET_IS_ORDERS_COLLECTION_GROUP_LIST_LOADING,
	payload,
});

export const GET_COLLECTION_WAY_LIST = 'orders-groups/GET_COLLECTION_WAY_LIST';
export const getCollectionWayListAction = payload => ({
	type: GET_COLLECTION_WAY_LIST,
	payload,
});

export const SET_COLLECTION_WAY_LIST = 'orders-groups/SET_COLLECTION_WAY_LIST';
export const setCollectionWayListAction = (id, payload) => ({
	type: SET_COLLECTION_WAY_LIST,
	id,
	payload,
});

export const SET_IS_COLLECTION_WAY_LIST_LOADING = 'orders-groups/SET_IS_COLLECTION_WAY_LIST_LOADING';
export const setIsCollectionWayListLoadingAction = payload => ({
	type: SET_IS_COLLECTION_WAY_LIST_LOADING,
	payload,
});

export const RESET_IS_COLLECTION_WAY_LIST_LOADING = 'orders-groups/RESET_IS_COLLECTION_WAY_LIST_LOADING';
export const resetIsCollectionWayListLoadingAction = payload => ({
	type: RESET_IS_COLLECTION_WAY_LIST_LOADING,
	payload,
});

export const GET_ORDERS_COLLECTION_WAY_LIST = 'orders-groups/GET_ORDERS_COLLECTION_WAY_LIST';
export const getOrdersCollectionWayListAction = payload => ({
	type: GET_ORDERS_COLLECTION_WAY_LIST,
	payload,
});

export const SET_ORDERS_COLLECTION_WAY_LIST = 'orders-groups/SET_ORDERS_COLLECTION_WAY_LIST';
export const setOrdersCollectionWayListAction = (id, payload) => ({
	type: SET_ORDERS_COLLECTION_WAY_LIST,
	id,
	payload,
});

export const SET_IS_ORDERS_COLLECTION_WAY_LIST_LOADING = 'orders-groups/SET_IS_ORDERS_COLLECTION_WAY_LIST_LOADING';
export const setIsOrdersCollectionWayListLoadingAction = payload => ({
	type: SET_IS_ORDERS_COLLECTION_WAY_LIST_LOADING,
	payload,
});

export const RESET_IS_ORDERS_COLLECTION_WAY_LIST_LOADING = 'orders-groups/RESET_IS_ORDERS_COLLECTION_WAY_LIST_LOADING';
export const resetIsOrdersCollectionWayListLoadingAction = payload => ({
	type: RESET_IS_ORDERS_COLLECTION_WAY_LIST_LOADING,
	payload,
});

export const GET_WAYS_GROUP_LIST = 'orders-groups/GET_WAYS_GROUP_LIST';
export const getWaysGroupListAction = payload => ({
	type: GET_WAYS_GROUP_LIST,
	payload,
});

export const SET_WAYS_GROUP_LIST = 'orders-groups/SET_WAYS_GROUP_LIST';
export const setWaysGroupListAction = (id, payload) => ({
	type: SET_WAYS_GROUP_LIST,
	id,
	payload,
});

export const SET_IS_WAYS_GROUP_LIST_LOADING = 'orders-groups/SET_IS_WAYS_GROUP_LIST_LOADING';
export const setIsWaysGroupListLoadingAction = payload => ({
	type: SET_IS_WAYS_GROUP_LIST_LOADING,
	payload,
});

export const RESET_IS_WAYS_GROUP_LIST_LOADING = 'orders-groups/RESET_IS_WAYS_GROUP_LIST_LOADING';
export const resetIsWaysGroupListLoadingAction = payload => ({
	type: RESET_IS_WAYS_GROUP_LIST_LOADING,
	payload,
});

export const GET_MODES = 'orders-groups/GET_MODES';
export const getModesAction = payload => ({
	type: GET_MODES,
	payload,
});

export const SET_MODES = 'orders-groups/SET_MODES';
export const setModesAction = payload => ({
	type: SET_MODES,
	payload,
});

export const SET_IS_MODES_LOADING = 'orders-groups/SET_IS_MODES_LOADING';
export const setIsModesLoadingAction = payload => ({
	type: SET_IS_MODES_LOADING,
	payload,
});

export const GROUP_REGROUP = 'orders-groups/GROUP_REGROUP';
export const orderGroupRegroupAction = payload => ({
	type: GROUP_REGROUP,
	payload,
});

export const ORDERS_REGROUP = 'orders-groups/ORDERS_REGROUP';
export const ordersRegroupAction = payload => ({
	type: ORDERS_REGROUP,
	payload,
});

export const GROUP_RESET = 'orders-groups/GROUP_RESET';
export const orderGroupResetAction = payload => ({
	type: GROUP_RESET,
	payload,
});

export const SET_IS_LOADING = 'orders-groups/SET_IS_LOADING';
export const setIsLoadingAction = payload => ({
	type: SET_IS_LOADING,
	payload,
});

export const SET_GROUP_OPEN = 'orders-groups/SET_GROUP_OPEN';
export const setGroupOpenAction = payload => ({
	type: SET_GROUP_OPEN,
	payload,
});

export const SET_COLLECTION_GROUP_OPEN = 'orders-groups/SET_COLLECTION_GROUP_OPEN';
export const setCollectionGroupOpenAction = payload => ({
	type: SET_COLLECTION_GROUP_OPEN,
	payload,
});

export const SET_GROUP_WAY_OPEN = 'orders-groups/SET_GROUP_WAY_OPEN';
export const setGroupWayOpenAction = payload => ({
	type: SET_GROUP_WAY_OPEN,
	payload,
});

export const SET_WAY_OPEN = 'orders-groups/SET_WAY_OPEN';
export const setWayOpenAction = payload => ({
	type: SET_WAY_OPEN,
	payload,
});

export const SET_COLLECTION_WAY_OPEN = 'orders-groups/SET_COLLECTION_WAY_OPEN';
export const setCollectionWayOpenAction = payload => ({
	type: SET_COLLECTION_WAY_OPEN,
	payload,
});
